var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Music/plus/circle",
    clipPath: "url(#clip0_41_976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.6667 7.99999H5.33333M8 10.6667V5.33332M0.666664 7.99999C0.666664 12.0501 3.94991 15.3333 8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 7.99999C15.3333 3.9499 12.0501 0.666656 8 0.666656C3.94991 0.666656 0.666664 3.9499 0.666664 7.99999Z",
    stroke: "#026735",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.a5d18b44ff1d2afe533d57857e38d749.svg";
export { ForwardRef as ReactComponent };